/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartNbox = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13 1v10h10v2H13v10h-2V13H1v-2h10V1zM9 21v2H5v-2zm-6 0v2H1v-2zm20 0v2h-2v-2zM7 17v2H1v-2zm16 0v2h-8v-2zm0-12v2h-4V5zM8 5v2H1V5zM5 1v2H1V1zm18 0v2h-8V1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartNbox as ChartNbox };
